import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { IonContent, IonLoading, IonToast } from '@ionic/react';

// Components
import { HeaderComponent, HomeComponent } from '../../../components';

// Helpers
import { extractConfigPage, resolveColorMessageByStatusCode } from '../../../helpers';

// Constants
import { APP_CONFIG } from '../../../constants';

// Actions
import { startGetTransactionMetadataAction, setErrorAction, resetErrorAction } from '../../../redux';

// Sass
import './HomePage.scss';

export const HomePage = ({ menuRef, userPermission }) => {

    const dispatch = useDispatch();
    const location = useLocation();
    const pageConfig = extractConfigPage(location);
    const { loading, error } = useSelector(state => state.app);
    const { user } = useSelector(state => state.auth);
    const { metadata } = useSelector(state => state.transaction);
    const [showToast, setShowToast] = useState({ show: false, error: null, status: null });

    useEffect(() => {

        if (!loading && metadata.files.length === 0) {

            dispatch(startGetTransactionMetadataAction());
        }

    }, [metadata.files]);

    /**
     * En caso de ocurrir cualquier error al intentar descargar el archivo de transacciones
     */
    useEffect(() => {

        if (error) {

            setShowToast({ show: true, error: error.message, status: error.status });
            dispatch(resetErrorAction());
        }

    }, [error]);

    return (
        <>
            <HeaderComponent
                title={pageConfig.title}
                menuRef={menuRef}
            />

            <IonLoading
                isOpen={loading}
                message={APP_CONFIG.CONTROLS.LOADING.MESSAGE}
            />

            <IonToast
                isOpen={showToast.show}
                onDidDismiss={() => setShowToast({ show: false, error: null })}
                message={showToast.error}
                duration={APP_CONFIG.CONTROLS.TOAST.DURATION}
                position={APP_CONFIG.CONTROLS.TOAST.POSITION}
                color={resolveColorMessageByStatusCode(showToast.status)}
            />

            <IonContent className="ion-padding">

                {!loading &&
                    <HomeComponent
                        accountMetadata={user.metadata}
                        confirmedTransactionsCount={metadata.count}
                        filesTransactions={metadata.files}
                        userPermission={userPermission}
                        eventError={(error) => dispatch(setErrorAction(error))}
                    />
                }
            </IonContent>
        </>
    )
}
